function splitCategoryNames(categoryNames) {
  return (categoryNames || '')
    .split(/[、,，/]/)
    .map((item) => item.trim())
    .filter(Boolean)
}

export function normalizeSchemeCustomerItem(row) {
  if (!row) return null

  const tags = splitCategoryNames(row.categoryNames)
  const viewNum = Number(row.viewNum) || 0
  const score = Math.min(98, 80 + Math.min(viewNum, 9) * 2)

  return {
    id: row.id || '',
    name: row.name || '',
    company: '',
    role: '',
    area: '',
    industry: row.categoryNames || '',
    mobilePhone: row.mobilePhone || '',
    score,
    type: row.type || '',
    viewNum,
    lastDate: row.lastDate || '',
    tags: tags.length ? tags : ['待分类'],
    reason: row.categoryNames
      ? `匹配行业：${row.categoryNames}`
      : '待后端补充推荐原因',
    action: viewNum
      ? `累计浏览/对接 ${viewNum} 次`
      : '暂无浏览/对接记录',
    raw: row
  }
}
